import React from "react";
import { Container } from "reactstrap";
import { default as FooterComponent } from "../components/Footer/Footer";

const Footer = () => {
    return (
        <Container>
            <FooterComponent />
        </Container>
    );
};

export default Footer;
